function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.467 0 0 4.467 0 10s4.467 10 10 10 10-4.467 10-10S15.533 0 10 0zm1.244 16c0 .711-.555 1.244-1.244 1.244S8.778 16.69 8.778 16v-.244c0-.69.555-1.245 1.222-1.245.689 0 1.244.556 1.244 1.245V16zm.6-11.267l-.622 7.6a1.264 1.264 0 01-1.355 1.156c-.623-.045-1.09-.556-1.134-1.156l-.622-7.6c-.111-1 .822-1.977 1.822-1.977 1.111 0 2 .977 1.911 1.977z",
  fill: "currentColor"
});
function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgAlert;